import { Heading } from '@/components/Cms/Heading';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { NextImage } from '@/components/NextImage';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';

import type { CardProps } from '../../types';

import * as S from './MyAccount.styles';

export const MyAccount = ({
  aspectRatio,
  className,
  headingTextColor,
  icon,
  media,
  mediaWrapperType,
  placeholderHeading,
  preload,
  sizes,
  url,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  return (
    <S.Wrapper
      as={url ? LinkWithLocale : 'div'}
      {...(!!url && { href: url })}
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
    >
      <MediaWrapper
        aspectRatio={aspectRatio}
        mediaWrapperType={mediaWrapperType}
        {...(media as ContentfulImageWithFocalPointFragment)}
        preload={preload}
        sizes={sizes}
      />
      <S.Content gridGap={2}>
        {icon && (
          <NextImage
            alt={icon.title ?? ''}
            height={48}
            src={icon.url ?? ''}
            width={48}
          />
        )}
        {placeholderHeading && (
          <Heading
            Heading={placeholderHeading}
            color={placeholderHeading?.mainColor ?? headingTextColor}
          />
        )}
      </S.Content>
    </S.Wrapper>
  );
};
